import { useCallback } from 'preact/hooks'
import { pattern } from '@gsc/utils'
import { useAppSelector } from '../store/store'
import { selectTemplateTagsForWidget } from '../store/widgets'
import { useWidgetContext } from './useWidgetContext'

export interface UseTemplateTags {
  template(input: string): string
}

export const useTemplateTags = (): UseTemplateTags => {
  const { widgetId } = useWidgetContext()
  const templateTags = useAppSelector(state => selectTemplateTagsForWidget(state, widgetId))

  return {
    template: useCallback(
      (input: string) => {
        return PREVIEW ? input : pattern(input, templateTags)
      },
      [templateTags],
    ),
  }
}
